import React from 'react';
import PropTypes from 'prop-types';
import { Text, View } from 'react-native';
import { Hr, Rating, ExpandableText } from 'LocalGluons';
import { fontStyles } from 'Theme/Theme';
import {
    getAssetSubtitle,
    getAssetTitle,
    getAssetDescription,
    isTvLikeType,
    ratingToStars,
    EMPTY_STRING_REGEXP
} from 'Utils';
import { Device } from 'DeviceUtils';

import { getRecordIconByType, getRecordingForItem } from 'Utils/itemUtils';
import { t } from 'Locale';
import { TITLE_NUMBERING_EPISODE } from '@24i/st-api-connector/utils';
import defaultStyles, {
    playerInfoStyles,
    webDescription,
    detailsPopupStyles
} from './AssetDetail.jss';
import Icon from '../Icon';
import { CachedImage } from '../CachedImage';

// const getRating = (item) => {
//     const rating = item.data ? item.data.csfdRating : null;
//     return rating ? <Rating value={ratingToStars(rating)} /> : null;
// };

// eslint-disable-next-line max-statements
const AssetDetail = ({
    style,
    item,
    isPlayerInfo = false,
    children,
    subtitleStyle,
    isDetailsPopupAndWeb = false
}) => {
    const isItemTvLikeType = isTvLikeType(item);
    const description = getAssetDescription(item, item.locale);
    const nonEmptyDescription = !EMPTY_STRING_REGEXP.test(description);
    const recording = getRecordingForItem(item);
    const { ids } = recording;
    const channelLogoUri = item.data && (item.data.channelLogoUrl || item.data.channelLogo);

    const bottomDividerStyle = isPlayerInfo
        ? playerInfoStyles?.bottomDivider
        : defaultStyles.bottomDivider;

    return (
        <View style={style}>
            {Boolean(channelLogoUri) && (
                <>
                    <CachedImage
                        style={[
                            defaultStyles.channelIcon,
                            isDetailsPopupAndWeb && detailsPopupStyles?.channelIcon
                        ]}
                        resizeMode="cover"
                        source={{ uri: channelLogoUri }}
                    />
                    <View style={defaultStyles.line} />
                </>
            )}
            <View style={defaultStyles.titleContainer}>
                <Text style={[defaultStyles.title, isPlayerInfo && playerInfoStyles?.title]}>
                    {getAssetTitle(item, TITLE_NUMBERING_EPISODE)}
                </Text>

                <Text style={subtitleStyle}>{getAssetSubtitle(item, true)}</Text>
                {Object.keys(recording).length > 0 && (
                    <View style={defaultStyles.iconsContainer}>
                        <Icon
                            name={getRecordIconByType(recording.data)}
                            style={defaultStyles.recordingStateIcon}
                        />
                        {ids.iptv && (
                            <Icon name="device_stb" style={defaultStyles.recordingStateIcon} />
                        )}
                        {ids.go && (
                            <Icon
                                name="device_smartphone"
                                style={defaultStyles.recordingStateIcon}
                            />
                        )}
                    </View>
                )}
            </View>

            {/* {!isItemTvLikeType && (
                <View style={defaultStyles.ratingContainer}>{getRating(item)}</View>
            )} */}
            {isPlayerInfo && nonEmptyDescription && (
                <Hr style={{ ...bottomDividerStyle, ...defaultStyles.hrMargin }} />
            )}
            {children}
            <ExpandableText
                key={description.substring(0, 10)}
                style={Device.isWeb ? webDescription : defaultStyles.description}
                text={description}
                maxCharacters={Device.isMobile ? 200 : 400}
                expandTitle={t('COMMON.MORE')}
                condenseTextTitle={t('COMMON.LESS')}
            />
            {nonEmptyDescription && <Hr style={defaultStyles.bottomDivider} />}
        </View>
    );
};

AssetDetail.defaultProps = {
    style: {},
    children: [],
    subtitleStyle: fontStyles.subtitle
};

AssetDetail.propTypes = {
    style: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),
    item: PropTypes.shape({}).isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    subtitleStyle: PropTypes.object
};

export default AssetDetail;
